import { Box, CircularProgress } from "@mui/material";

type DisplayPageDataProps = {
  loading: boolean;
  data: any;
  error: any;
  children: React.ReactNode;
}

export function DisplayPageData({ loading, data, error, children }: DisplayPageDataProps) {
  return <>
    {loading && !data && <Box component="div" sx={{ marginTop: "20vh", textAlign: "center" }}><CircularProgress size={50} /></Box>}
    {(!loading || data) && !error && <>{children}</>}
    {!loading && error && <div>Error loading the data {error?.message ?? String(error)}</div>}
  </>;
}